module.exports = __webpack_public_path__ + "assets/merriweather-bolditalic.efa8aede50425e1581c5ef0054843a79fdd8422daac5d437ea7c61954c9e2c2e.woff2";